import './index.scss'
import '../../assets/scripts/countNumber'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'

//点击banner按钮，到下一屏
$('.about-know-banner .go-btn').on('click',function(){
  $("html, body").animate({
    scrollTop: $('.section1').offset().top
  }, {
      duration: 500,
      easing: "swing"
  });
})


//数字滚动效果
function numScroll () {
  let num1 = $("#scrollNum1").html()
  let num2 = $("#scrollNum2").html()
  let num3 = $("#scrollNum3").html()
  let num4 = $("#scrollNum4").html()
  $("#scrollNum1").rollNum({
      deVal: num1
  });
  $("#scrollNum2").rollNum({
      deVal: num2
  });
  $("#scrollNum3").rollNum({
      deVal: num3
  });
  $("#scrollNum4").rollNum({
      deVal: num4
  });
}

//页面滚动监听
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度
  var numTop = $('.section2 .num-cont').offset().top

  if (scroH > numTop - viewH) {
    numScroll ()
  }
});

var historyswiper = new Swiper(".section3 .history-swiper .mySwiper", {
  slidesPerView: 1.2,
  slidesPerGroup: 1,
  pagination: {
    el: ".section3 .swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1.3,
      slidesPerGroup: 1,
    },
    768: {
      slidesPerView: 2.2,
      slidesPerGroup: 2,
    },
    1024: {
      slidesPerView: 2.5,
      slidesPerGroup: 2,
    },
    1280: {
      slidesPerView: 3.5,
      slidesPerGroup: 3,
    },
  },
});


var locationswiper = new Swiper(".section4 .cont .mySwiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  breakpoints: {
    1024: {
      autoHeight: false,
    },
  },
  
  on: {
    init: function(swiper){
      $('.section4 .location-tab li').eq(0).addClass('active')
    }, 
    transitionStart: function(swiper){
      $('.section4 .location-tab li').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".section4 .location-tab li").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          locationswiper.slideTo($(_self).index())
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
        }, 201);
      });
    });
});


var honorswiper = new Swiper(".section6 .list-cont .mySwiper", {
  // allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  navigation: {
    nextEl: ".section6 .list-cont .swiper-button-next",
    prevEl: ".section6 .list-cont .swiper-button-prev",
  },
  on: {
    init: function(swiper){
      $('.section6 .logo-cont li').eq(0).addClass('active')
    }, 
    transitionStart: function(swiper){
      $('.section6 .logo-cont li').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

var mouseover_tid2 = [];
var mouseout_tid2 = [];
$(document).ready(function () {
  $(".section6 .logo-cont li").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid2[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid2[ index ] = setTimeout(function () {
          honorswiper.slideTo($(_self).index())
          // if($(window).width()<640){
          //   $("html, body").animate({
          //       scrollTop: $('.section6 .list-cont').offset().top-100 + "px"
          //   }, {
          //       duration: 500,
          //       easing: "swing"
          //   });
          // }
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid2[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid2[ index ] = setTimeout(function () {
        }, 201);
      });
    });
});

//锚点平滑滚动
$(function () {
  $(".about-know-banner .sub-title a").on('click',function () {
      $("html, body").animate({
          scrollTop: $($(this).attr("href")).offset().top + "px"
      }, {
          duration: 500,
          easing: "swing"
      });
      return false;
  });
});